import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import RightBanners from "../components/rightbanners";
import SeoHeaders from "../components/seoheaders";
import Loading from "../components/loading";
import * as wConsts from "../consts/website-consts";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import SwBanner from "../components/swbanner";
import BuyAdBanner from "../components/buyadbanner";
import Select from "react-select";

class Pay extends Component {

  componentDidMount() {
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "pay" });

  }
  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }
  render() {

    if(!this.props.WebPage.PageLoaded) {
      return (
        <Loading/>
      );
    }

    let showBan = this.props.WebPage.Settings.ShowRightBanners;
    return (
      <div className="content-wrap">
        <SeoHeaders Position={"Top"}/>
        <div className={`cell ${showBan ? "x9" : "x12"} white-wrap the-content`}>
          <div className="popup-content">

            <div className="center-page">
              <form>
                <div className="input-block">
                  <label>Email</label>
                  <input type="text" placeholder="me@email.com" />
                </div>
                <div className="input-block">
                  <label>Pay amount</label>
                  <input type="text" placeholder={"29.99"} />
                  <p style={{color: "#D94951", fontSize: "14px"}}><i className="fa fa-info-circle"></i> Payment amount in euros <i className="fa fa-euro-sign"></i> currency.</p>
                </div>
                <div className="input-block">
                  <label>Pay for</label>
                  <input type="textarea" placeholder={"Enter payment details"} />
                  <p style={{color: "#D94951", fontSize: "14px"}}><i className="fa fa-info-circle"></i> Enter your name, contact info or other info</p>
                </div>
                <div className="input-block" style={{marginBottom: "40px"}}>
                  <label>Pay by</label>
                  <Select
                    options = {[
                      {value: 10001, label: "VXS/Credit Card"},
                      {value: 10002, label: "DialXS(Ideal,Paysafe,Banking)"},
                      {value: 10003, label: "Classified Bundles(Pay To Bitcoin)"},
                    ]}
                    defaultValue={{value: 10001, label: "VXS/Credit Card"}}
                  />
                </div>


                <input type="submit" className="button full" name="" onClick={(evt) => {
                  evt.preventDefault();
                  this.props.dispatch(wActs.showWarning("INFO","Coming soon..."))
                }} value={this.getTranslation("page.submit")}/>
              </form>
            </div>

          </div>

          <div className="clearfix m-b-xl"></div>

          <div className="footer-text" style={{background: "white", padding: "15px"}} ><pre dangerouslySetInnerHTML={{__html: this.getTranslation("page.footer.thebiggestnetworkintheworld")}}></pre></div>
          <div className={"flex-center"} style={{background: "white"}}>
            <div className={"four-center-banner"}>
              <SwBanner apiAnonId={this.props.WebPage.Request.AnonymousId} tagText={this.props.WebPage.Settings.HtmlSections['Adserver-300x100-ournetwork']} className={"network-banners"} ApiReferer={this.props.WebPage.ServerParams.Referer}>
                <BuyAdBanner size={"300x100"} hideBottom={true} textButton={"Advertise here!"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")}/>
              </SwBanner>
            </div>
          </div>
        </div>

        {showBan &&
        <div className="cell x3">
          <RightBanners/>
        </div>
        }

        <SeoHeaders Position={"Bottom"}/>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Pay);
